<app-lms-modal-frame [title]="'Income ' + payslipModel?.month" [pageHeadWidth]="420">
  <div modal-body class="center-screen">
    <div class="card">
      <div class="card-body">
        <form [formGroup]="payslipForm">
          <table class="table table-auto table-sm shadow-2-strong rounded-1">
            <tbody  class="field-4column-label">
              <tr class="border-paydate">
                <td style="width: 15%" class="py-4">Pay Date:</td>
                <td class="py-4 ps-0" style="text-align:left;">
                  <div class="input-group input-group-sm" style="min-width: 180px; width: 200px;">
                    <input class="form-control rounded-end" readonly aria-readonly="true" style="background: transparent;" [mdbDatepicker]="picker"  [max]="maxDate | date: 'yyyy-MM-dd'" placeholder="YYYY-MM-DD"
                      formControlName="payslipDate" style="cursor: pointer;" (click)="picker.toggle()" />
                    <mdb-datepicker-toggle [mdbDatepicker]="picker" icon="fas fa-calendar-alt" color="primary"></mdb-datepicker-toggle>
                    <div class="input-group-text border-0" (click)="picker.toggle()">
                      <mdb-datepicker mdbDatepicker #picker [confirmDateOnSelect]="true" [format]="'yyyy-mm-dd'"></mdb-datepicker>
                    </div>
                  </div>
                  <div *ngIf="payslipDate?.invalid">
                    <div *ngIf="payslipDate?.errors?.required">
                      <small class="text-danger">Pay date is required</small>
                    </div>
                    <div *ngIf="payslipDate?.errors?.invalidDate">
                      <small class="text-danger">Invalid date</small>
                    </div>
                  </div>

                </td>
              </tr>
              <!-- New Gross Income Field -->
              <tr>
                <td style="min-width: 15%">Gross Income:</td>
                <td class="income-left">
                  <div class="input-group input-group-sm" style="width: 180px;">
                    <span class="input-group-text text-small"><strong>R</strong></span>
                    <input class="form-control" formControlName="grossIncome" lmsNumbersOnly [allowDecimals]="true"
                      [class.ng-valid]="grossIncome?.valid" [class.ng-invalid]="grossIncome?.invalid" min="0"
                      [readonly]="clientType === 'SASSA' || clientType === 'Pensioner'">
                  </div>
                  <div *ngIf="grossIncome?.invalid">
                    <div *ngIf="grossIncome?.errors?.required">
                      <small class="text-danger">Gross income amount is required</small>
                    </div>
                  </div>
                  <div *ngIf="clientType === 'SASSA' || clientType === 'Pensioner'">
                    <small class="text-muted">For {{clientType === 'SASSA' ? 'SASSA' : 'Pensioner'}} clients, gross income equals net income</small>
                  </div>
                </td>
              </tr>
              <tr>
                <td style="min-width: 25%">Nett Income:</td>
                <td class="income-left">
                  <div class="input-group input-group-sm" style="width: 180px;">
                    <span class="input-group-text text-small"><strong>R</strong></span>
                    <input class="form-control" formControlName="nettIncome" lmsNumbersOnly [allowDecimals]="true"
                      [class.ng-valid]="nettIncome?.valid" [class.ng-invalid]="nettIncome?.invalid" min="0">
                  </div>
                  <div *ngIf="nettIncome?.invalid" >
                    <div *ngIf="nettIncome?.errors?.numberOnly">
                      <small class="text-danger">Only numeric values!</small>
                    </div>
                    <div *ngIf="nettIncome?.errors?.required">
                      <small class="text-danger">Income amount is required</small>
                    </div>
                  </div>
                  <!-- <div *ngIf="calculateError"  class="error-label">
                    Payslip values are incorrect
                  </div> -->
                </td>
              </tr>
              <tr *ngIf="clientType === 'Salaried' || clientType === 'Pensioner'">
                <td style="width: 15%">Other Income:</td>
                <td class="income-left">
                  <div class="input-group input-group-sm" style="width: 180px;">
                    <span class="input-group-text text-small"><strong>R</strong></span>
                    <input class="form-control" formControlName="otherIncome" lmsNumbersOnly [allowDecimals]="true"
                      min="0">
                  </div>
                  <div *ngIf="otherIncome?.invalid" >
                  <div *ngIf="otherIncome?.errors?.numberOnly">
                    <small class="text-danger">Only numeric values!</small>
                  </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </form>
      </div>
    </div>
  </div>

  <div modal-actions class="flex-container">
    <button class="btn btn-sm btn-primary" type="button" (click)="closeDialog()">Close</button>
    <button class="btn btn-sm btn-primary" type="button" (click)="save()" [disabled]="invalidDate ? 'disabled' : null">Save</button>
  </div>
</app-lms-modal-frame>
